import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Domain, DomainServiceInfo, DomainServicesState, DomainStatistic, UserServiceBackupInfo } from '@common/models';
import { ODataServiceFactory } from '@common/odata';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class DomainService {
  private readonly odataFactory = inject(ODataServiceFactory);
  private readonly http = inject(HttpClient);

  fetchDomain(domainId: string): Observable<Domain> {
    const odataService = this.odataFactory.CreateService(`Domains(${domainId})`);

    return this.http.get<Domain>(odataService.Query().GetUrl());
  }

  fetchDomainServiceInfo(serviceName: string, domainId: string): Observable<UserServiceBackupInfo> {
    const odataService = this.odataFactory.CreateService(`Domains(${domainId})?$expand=${serviceName}`);

    return this.http.get<Domain>(odataService.Query().GetUrl()).pipe(
      map((domain) => {
        const { LastBackupDate, Size: TotalSize } = domain[serviceName] as DomainServiceInfo;

        return { LastBackupDate, TotalSize };
      })
    );
  }

  fetchDomainStatistic(): Observable<DomainStatistic> {
    const odataService = this.odataFactory.CreateService(`GetDomainUsersStatistic`);

    return this.http.get<DomainStatistic>(odataService.Query().GetUrl());
  }

  fetchDomainServicesState(): Observable<DomainServicesState> {
    const odataService = this.odataFactory.CreateService(`GetDomainServicesState`);

    return this.http.get<DomainServicesState>(odataService.Query().GetUrl());
  }

  syncDomain(domainId: string): Observable<void> {
    const odataService = this.odataFactory.CreateService(`Domains(${domainId})/Sync`);

    return this.http.post<void>(odataService.Query().GetUrl(), null);
  }
}
